import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import React from "react";
import Image from "react-bootstrap/Image";
import _ from "lodash";
import * as clientSelectors from "../../../../selectors/client";
import EmptyItemView from "../../../../components/EmptyItemView";

function ActionRequiredRetailSection({ data }) {

  return (
    <div className="shadow mt-4 mb-5">
      <div className={clsx("custom-card-action-required-label-container d-flex align-items-center")}>
        <Image src="/img/icon/chat-alert-outline.png" rounded />
        <h2>Action Required</h2>
      </div>
      <div className={clsx("custom-card-label-action-required-container")}>
        <h3>List of Purchase Due</h3>
        {!_.isEmpty(data) ? (
          _.map(data, (item, index) => {
            const clientData = data[index];
            const groupByClientData = _.groupBy(clientData, "currency_code");
            return (
              <div key={index}>
                {groupByClientData &&
                  _.map(groupByClientData, (clientItems, index) => {
                    return (
                      <div key={index} className={clsx("mt-3")}>
                        <Table responsive="md">
                          <thead>
                          <tr className={"styled-action-required-table"}>
                            <th style={{ minWidth: '100px' }}>Reference No</th>
                            <th style={{ minWidth: '60px' }}>Currency</th>
                            <th style={{ minWidth: '80px' }}>Stock Code</th>
                            <th style={{ minWidth: '210px'}}>Stock Name</th>
                            <th style={{ minWidth: '160px'}}>Outstanding Quantity</th>
                            <th style={{ minWidth: '160px'}}>Transaction Price</th>
                            <th style={{ minWidth: '160px'}}>Outstanding Amount</th>
                            <th style={{ minWidth: '120px'}}>Due Date</th>
                          </tr>
                          </thead>
                          <tbody>
                          {clientItems &&
                            _.map(clientItems, (clientItem,index) => {
                              const contractReference =
                                clientSelectors.getClientContractReference(clientItem);
                              const stockCode = clientSelectors.getClientStockCode(clientItem);
                              const stockName = clientSelectors.getClientStockName(clientItem);
                              const outstandingQuantity =
                                clientSelectors.getClientOutstandingQuantity(clientItem);
                              const outstandingAmount =
                                clientSelectors.getClientOutstandingAmountFullText(clientItem);
                              const dueDate = clientSelectors.getClientDueDate(clientItem);
                              const currencyCode = clientSelectors.getClientCurrencyCode(clientItem);
                              const transactionPrice =
                                clientSelectors.getClientTransactionPriceFullText(clientItem);

                              return (
                                <tr key={index}>
                                  <td>{contractReference}</td>
                                  <td>{currencyCode}</td>
                                  <td>{stockCode}</td>
                                  <td>{stockName}</td>
                                  <td>{outstandingQuantity}</td>
                                  <td>{transactionPrice}</td>
                                  <td>
                                    {outstandingAmount}
                                  </td>
                                  <td>{dueDate}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    );
                  })}
              </div>
            );
          })
        ) : (
          <EmptyItemView title="No Contracts Due" />
        )}
      </div>
    </div>
  );
}

export default ActionRequiredRetailSection;
